import {
  DetalheTurma,
  DisciplinaDetalheTurma,
  ObjetoDisciplinaTurma,
  TemaDisciplinaTurma,
} from '../../../contexts/turmas/turma-selecionada/turma-selecionada.types';
import { HorarioTurma, LocalTurma } from '../../../contexts/turmas/turmas.types';
import { EducadorTurma, FormatoTurma, PerfilResponsavel, TipoCurso, TipoTurma } from '../../../types';

import { FixtureTurmaSelecionada } from './turma-selecionada.types';

export const turmaSelecionadaFixture: FixtureTurmaSelecionada = () => {
  const mockDisciplina: DisciplinaDetalheTurma = {
    codigo: 'ARA_TST',
    nome: 'História da Arte',
    objetos: [],
    temas: [],
    zeroDuvidas: false,
    tutoriaZeroDuvidas: false,
    embaixadora: false,
  };

  const mock: DetalheTurma = {
    id: '1',
    marca: 'estacio',
    codigoEntrega: 'estacio_15',
    disciplina: mockDisciplina,
    formato: FormatoTurma.PRESENCIAL,
    periodoAcademico: '2021.2',
    campus: 'Rio de Janeiro',
    local: { salas: ['417'], blocos: ['A'] },
    horarios: [{ diaSemana: 'segunda', horaInicio: '09:00', horaFim: '10:00' }],
    educadorResponsavel: { nome: 'Claudia Oliveira', perfil: PerfilResponsavel.PROFESSOR },
    educadores: [{ nome: 'Jeff Bezos', perfil: PerfilResponsavel.PROFESSOR }],
    totalAlunosMatriculados: 60,
    habilitarAgendamentoLaboratorio: false,
    habilitarComunidadeZeroDuvidas: false,
    habilitarTutoriaZeroDuvidas: false,
    habilitarAtendimentoCoordenacaoZeroDuvidas: false,
    habilitarRedirecionamentoTeams: false,
    tipoTurma: 'NORMAL',
    tipoCurso: 'GRADUAÇÃO',
    turmaCursada: false,
    periodoCursadoAluno: null,
  };

  return {
    create: () => {
      const detalhesEntrega: DetalheTurma = { ...mock };

      return {
        id: function (param: string) {
          detalhesEntrega.id = param;
          return this;
        },
        marca: function (param: string) {
          detalhesEntrega.marca = param;
          return this;
        },
        campus: function (param: string) {
          detalhesEntrega.marca = param;
          return this;
        },
        codigoEntrega: function (param: string) {
          detalhesEntrega.codigoEntrega = param;
          return this;
        },
        digital: function () {
          detalhesEntrega.formato = FormatoTurma.DIGITAL;
          return this;
        },
        periodoAcademico: function (param: string) {
          detalhesEntrega.periodoAcademico = param;
          return this;
        },
        semPeriodoAcademico: function () {
          detalhesEntrega.periodoAcademico = undefined;
          return this;
        },
        disciplinaNome: function (param: string) {
          detalhesEntrega.disciplina.nome = param;
          return this;
        },
        disciplinaCodigo: function (param: string) {
          detalhesEntrega.disciplina.codigo = param;
          return this;
        },
        disciplinaZeroDuvida: function (param: boolean) {
          detalhesEntrega.disciplina.zeroDuvidas = param;
          return this;
        },
        disciplinaTutoriaZeroDuvida: function (param: boolean) {
          detalhesEntrega.disciplina.tutoriaZeroDuvidas = param;
          return this;
        },
        disciplinaAgendamentoLaboratorio: function (param: boolean) {
          detalhesEntrega.disciplina.tutoriaZeroDuvidas = param;
          return this;
        },
        disciplinaObjetos: function (param: ObjetoDisciplinaTurma[]) {
          detalhesEntrega.disciplina.objetos = param;
          return this;
        },
        disciplinaTemas: function (param: TemaDisciplinaTurma[]) {
          detalhesEntrega.disciplina.temas = param;
          return this;
        },
        educadoresDaEntrega: function (param: EducadorTurma[]) {
          detalhesEntrega.educadores = param;

          return this;
        },
        educadorResponsavel: function (param: EducadorTurma) {
          detalhesEntrega.educadorResponsavel = param;

          return this;
        },
        alunosMatriculados: function (param: number) {
          detalhesEntrega.totalAlunosMatriculados = param;

          return this;
        },
        habilitarAgendamentoLaboratorio: function () {
          detalhesEntrega.habilitarAgendamentoLaboratorio = true;

          return this;
        },
        local: function (param: LocalTurma) {
          detalhesEntrega.local = param;

          return this;
        },
        semLocal: function () {
          detalhesEntrega.local = undefined;

          return this;
        },
        horariosDaEntrega: function (param: HorarioTurma[]) {
          detalhesEntrega.horarios = param;

          return this;
        },
        tipoTurma: function (param: TipoTurma) {
          detalhesEntrega.tipoTurma = param;

          return this;
        },
        turmaPai: function () {
          detalhesEntrega.tipoTurma = 'PAI';

          return this;
        },
        tipoCurso: function (param: TipoCurso) {
          detalhesEntrega.tipoCurso = param;
          return this;
        },
        cursoEspecializacao: function () {
          detalhesEntrega.tipoCurso = 'ESPECIALIZAÇÃO';
          return this;
        },
        onboarding: function () {
          detalhesEntrega.id = 'yduqs_COM0001';
          detalhesEntrega.codigoEntrega = 'ARACOM0001';
          detalhesEntrega.campus = null;
          detalhesEntrega.educadores = [];
          detalhesEntrega.horarios = null;
          detalhesEntrega.local = null;
          detalhesEntrega.totalAlunosMatriculados = 0;
          detalhesEntrega.disciplina.codigo = 'COM0001';
          detalhesEntrega.disciplina.nome = 'PRIMEIROS PASSOS';

          return this;
        },
        get: function () {
          return detalhesEntrega;
        },
      };
    },
  };
};
